import { Reveal, SectionLabel } from "./Reveal";

const STATS = [
  { value: "30+", label: "Years on the brush" },
  { value: "01", label: "Painter, start to finish" },
  { value: "100%", label: "NSW local" },
];

export default function About() {
  return (
    <section
      id="craig"
      data-testid="about-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 border-t border-line"
    >
      <div className="max-w-3xl">
          <Reveal>
            <SectionLabel>The Painter</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-8 leading-[1.05]">
              Thirty years
              <br />
              <span className="italic text-smoke">on the brush.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-smoke font-light leading-relaxed mt-10 max-w-xl text-base md:text-lg">
              Craig has spent three decades painting homes across Australia.
              No crew roulette, no subcontractors — the same steady hand quotes
              the job, preps the surfaces and lays the final coat.
            </p>
            <p className="text-smoke font-light leading-relaxed mt-6 max-w-xl text-base md:text-lg">
              Clients don't describe him as flashy. They describe him as
              efficient, on time, and particular — which, in this trade, is the
              highest praise there is.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <blockquote className="mt-12 border-l-2 border-ember pl-8 max-w-xl">
              <p className="font-serif italic text-xl md:text-2xl font-light text-bone/90 leading-relaxed">
                "He is particular, and his thirty years as a painter shows in
                his work."
              </p>
              <cite className="not-italic block mt-4 text-xs uppercase tracking-[0.25em] text-smoke">
                — Jeanette B
              </cite>
            </blockquote>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="grid grid-cols-3 gap-8 mt-16 pt-10 border-t border-line max-w-xl">
              {STATS.map((s) => (
                <div key={s.label}>
                  <p className="font-serif font-light text-4xl md:text-5xl text-ember">
                    {s.value}
                  </p>
                  <p className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-smoke mt-3 leading-relaxed">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
    </section>
  );
}
